"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CompetitionsMap = _interopRequireDefault(require("../../../core/CompetitionsMap"));
var _jumbotron = _interopRequireDefault(require("../../../core/jumbotron"));
var _selectMultiCode = _interopRequireDefault(require("../../../core/select-multi-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", {
  className: "col-sm-2 col-lg-2"
}, "Filter:");
class ApplicationsMap extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      selectedTiers: []
    });
    _defineProperty(this, "_onToggleTiers", (id, value) => {
      this.setState({
        selectedTiers: value ? this.state.selectedTiers.concat([id]) : this.state.selectedTiers.filter(i => i !== id)
      });
    });
    _defineProperty(this, "_getMapLabels", () => {
      const racesBySiteIDs = {};
      const racesBySites = [];
      const selectedTiers = this.state.selectedTiers;
      const raceStarts = this.props.calendar.applicationRacing.filter(r => (!selectedTiers.length || selectedTiers.includes(r.tierRef)) & r.isRaceStartDay & r.application.applicationStatusRef !== 'DECL');
      raceStarts.map(r => {
        const site = r.application.site;
        if (!racesBySiteIDs[site.id]) {
          racesBySiteIDs[site.id] = {
            siteLocation: site.abbreviation || site.location,
            sitePosition: {
              lat: +(site.latitude || 55),
              lng: +(site.longitude || 1.8)
            },
            races: 0
          };
          racesBySites.push(racesBySiteIDs[site.id]);
        }
        racesBySiteIDs[site.id].races = racesBySiteIDs[site.id].races + 1;
      });
      return racesBySites;
    });
  }
  render() {
    if (!this.props.userIsCalendarOfficer) return null;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_jumbotron.default, {
      size: "small"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, _ref, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-10 col-lg-10"
    }, /*#__PURE__*/_react.default.createElement(_selectMultiCode.default, {
      yearID: this.props.calendar.id,
      lookup: "CalendarTiers",
      name: "selectedTier",
      colSize: 4,
      selectedCodes: this.state.selectedTiers,
      onChange: this._onToggleTiers
    })))), /*#__PURE__*/_react.default.createElement(_CompetitionsMap.default, {
      mapLabels: this._getMapLabels()
    }));
  }

  // *******************************************************************************
  // Data and actions
  // *******************************************************************************
}
_defineProperty(ApplicationsMap, "partialQueries", {
  Calendar: {
    id: true,
    applicationRacing: {
      id: true,
      isRaceStartDay: true,
      tierRef: true,
      application: {
        id: true,
        applicationStatusRef: true,
        site: {
          id: true,
          location: true,
          abbreviation: true,
          latitude: true,
          longitude: true
        }
      }
    }
  }
});
var _default = exports.default = ApplicationsMap;